import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'GetStartedButton' })((_theme, _props, _classes) => ({
    root: {
        transition: 'all 0.2s'
    },
    _white: {
        color: '#0D121E',
        background: 'rgba(255, 255, 255, 0.85) !important',
        backdropFilter: 'blur(12px)',
        ['&:hover']: {
            background: '#fff !important'
        }
    },
    _black: {
        background: '#232323 !important',
        ['&:hover']: {
            background: '#393939 !important'
        },
        ['&:active']: {
            background: '#2D2D2D !important'
        },
        color: '#fff'
    },
    _small: {
        padding: '12px 16px',
        fontSize: 15,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 100
    },
    _regular: {
        padding: '20px 40px',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        borderRadius: 80
    }
}));
